module.exports = __webpack_public_path__ + "img/map-marker-parking.789b8aca.svg";